export enum MfsVendors {
  Bkash='Bkash',
  Nagad='Nagad',
  Rocket='Rocket',
}
